export default __webpack_public_path__ + "static/Typography-b836a12cb4055e2a78f0d20babbf435f.png";